/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : hightman (hightman@cloud-sun.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/user';
import { USER } from '@/store/types';
import { UserAccount } from '@/api/types/user';
import store from '..';

export interface StoreUserAccountState {
  list: UserAccount[];
  maxLimit: number;
}

export default {
  namespaced: true,
  state: {
    list: [],
    maxLimit: 0,
  },
  getters: {},
  actions: {
    [USER.GET_ACCOUNTS]({ commit, state }) {
      if (state.maxLimit === 0) {
        return new Promise<void>((resolve, reject) => {
          api.getAccounts([400]).then((res) => {
            commit(USER.GET_ACCOUNTS, {
              list: res.data,
              maxLimit: res.extra?.maxLimit,
            });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
    [USER.CREATE_ACCOUNT](_, { phone, code }) {
      return new Promise<void>((resolve, reject) => {
        api.createAccount(phone, code).then(() => {
          store.dispatch(`user/${USER.GET}`, { action: 'reload', silent: true }).finally(resolve);
        }).catch(reject);
      });
    },
    [USER.SET_ACCOUNT](_, { xid }) {
      return new Promise<void>((resolve, reject) => {
        api.setAccount(xid).then(() => {
          store.dispatch(`user/${USER.GET}`, { action: 'reload', silent: true }).finally(resolve);
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.GET_ACCOUNTS](state, { list, maxLimit }) {
      state.list = list;
      state.maxLimit = maxLimit || 0;
    },
  },
};
